import { MODAL_STYLES } from "../../constants/modal-styles";
import { ModalButton } from "./ModalButton";

interface ActionPanelProps {
  isOpen: boolean;
  language: "ka" | "en";
  code: string;
  onOpenGifts: () => void;
  onLeaveMessage: () => void;
  onLeaveAcquaintance: () => void;
  onCancel: () => void;
  onLanguageChange?: (lang: "ka" | "en") => void;
}

export const ActionPanel = ({
  isOpen,
  language,
  code,
  onOpenGifts,
  onLeaveMessage,
  onLeaveAcquaintance,
  onCancel,
  onLanguageChange,
}: ActionPanelProps) => {
  if (!isOpen) return null;

  const content = {
    ka: {
      title: "კოდი გააქტიურებულია",
      message: `კოდი "${code}" წარმატებით გამოყენებულია!`,
      openButton: "🎁 გახსნა (შეტყობინება/ზნაკომstvo/საჩუქარი)",
      leaveAcquaintanceButton: "👥 დატოვება (ზნაკომstvo)",
      leaveMessageButton: "💌 დატოვება (შეტყობინება)",
      cancelButton: "გაუქმება",
    },
    en: {
      title: "Code activated",
      message: `Code "${code}" successfully applied!`,
      openButton: "🎁 Open (Message/Acquaintance/Gift)",
      leaveAcquaintanceButton: "👥 Leave (Acquaintance)",
      leaveMessageButton: "💌 Leave (Message)",
      cancelButton: "Cancel",
    },
  };

  const text = content[language] || content.ka;

  return (
    <div className={MODAL_STYLES.bottomOverlay}>
      <div
        className={MODAL_STYLES.bottomModal}
        onClick={(e) => e.stopPropagation()}
        style={{
          fontFamily: MODAL_STYLES.fontFamily,
          maxWidth: '400px',
        }}
      >
        <div className={MODAL_STYLES.content}>
          <h2 className="text-base sm:text-lg font-bold text-amber-900 mb-3 text-center">
            {text.title}
          </h2>

          <p className="text-amber-900 text-xs sm:text-sm mb-4 text-center">
            {text.message}
          </p>

          <div className={MODAL_STYLES.buttonContainer}>
            <div className={MODAL_STYLES.buttonGroupThree}>
              <ModalButton onClick={onOpenGifts} fullWidth={true}>
                <span className="text-xs sm:text-sm">{text.openButton}</span>
              </ModalButton>

              <ModalButton onClick={onLeaveAcquaintance} fullWidth={true}>
                <span className="text-xs sm:text-sm">{text.leaveAcquaintanceButton}</span>
              </ModalButton>

              <ModalButton onClick={onLeaveMessage} fullWidth={true}>
                <span className="text-xs sm:text-sm">{text.leaveMessageButton}</span>
              </ModalButton>
            </div>

            <ModalButton onClick={onCancel} variant="secondary">
              <span className="text-xs sm:text-sm">{text.cancelButton}</span>
            </ModalButton>
          </div>
        </div>
      </div>
    </div>
  );
};
